import {useEffect} from 'react';

export default function useLoadMore({loadMore, enable = true}) {
  useEffect(() => {
    if (enable) {
      _addScrollEventListener();
    }

    return () => {
      if (enable) {
        _removeScrollEventListener();
      }
    }
  }, [enable]);

  const _addScrollEventListener = () => {
    document.querySelector('.app-main-content')?.addEventListener('scroll', _onScroll);
  }
  const _removeScrollEventListener = () => {
    document.querySelector('.app-main-content')?.removeEventListener('scroll', _onScroll);
  }

  const _onScroll = (evt) => {
    if (evt.target.scrollHeight - evt.target.scrollTop - evt.target.clientHeight < 60) {
      if (loadMore) loadMore();
    }
  }

  return {};
}
